import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  rounded?: 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const roundedMap = {
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  full: 'rounded-full',
} as const;

export function Skeleton({ rounded = 'lg', className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        roundedMap[rounded],
        'bg-[linear-gradient(110deg,#EAF1F7_8%,#F4F8FB_18%,#EAF1F7_33%)] bg-[length:200%_100%]',
        'motion-safe:animate-pulse',
        className,
      )}
      {...rest}
    />
  );
}

export default Skeleton;
